import SpendTimeTips from '../spend-time-tips'
export default {
  components: {
    SpendTimeTips
  },
  data () {
    return {
      formValidate: {
        timeSpent: (this.appDetail && this.appDetail.tencentInfo && this.appDetail.tencentInfo.time) ? this.appDetail.tencentInfo.time : undefined
      }
    }
  }
}
